export enum ForgotPasswordStepEnum {
  OTP = 'OTP',
  PIN = 'PIN',
  NID = 'NID',
  PHONE_NUMBER = 'PHONE_NUMBER',
}
